export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_2f9046af-7af3-4b75-9404-26f07761b801/artifacts/lubmpnsv_Limitless%20Clinical%20Intelligence.png",
  heroAthlete: "https://customer-assets.emergentagent.com/job_2f9046af-7af3-4b75-9404-26f07761b801/artifacts/9har0cfm_PATFZmgClN63d0DDI4iEy.png",
  maleCable: "https://customer-assets.emergentagent.com/job_2f9046af-7af3-4b75-9404-26f07761b801/artifacts/q9kxrrmk_oHzy3M4VLjSfiNwn-IC_C.png",
  coupleTraining: "https://customer-assets.emergentagent.com/job_2f9046af-7af3-4b75-9404-26f07761b801/artifacts/jtkshv72_PoDiQ2wpYHpPLLqy0lP2L.png",
  womenSquat: "https://customer-assets.emergentagent.com/job_2f9046af-7af3-4b75-9404-26f07761b801/artifacts/f48m51gr_eZ3G3a5e-0LL9GXv15v4t.png",
  aiDashboard: "https://customer-assets.emergentagent.com/job_c0aba642-558f-4c76-a786-354b09f9a0b4/artifacts/gvcc7edi_wDS5toN1SRWkXYuYlVtFL.png",
  doctorData: "https://customer-assets.emergentagent.com/job_c0aba642-558f-4c76-a786-354b09f9a0b4/artifacts/230k5fd3_8Mu1AQ5kkT__v3kfRynac.png",
  medicalTeam: "https://customer-assets.emergentagent.com/job_c0aba642-558f-4c76-a786-354b09f9a0b4/artifacts/pjy9fspi_g5axOtwNoO0w0JrHLqX5O.png",
};

export const LINKS = {
  jotform: "https://form.jotform.com/260552682989069",
  gamma: "https://gamma.app/docs/AI-Powered-Platform-tu46mbymymdxmi0",
};
